import { MODAL_PULLER_VERTICAL_SPACING, PULLER_HEIGHT, PULLER_WIDTH, Tokens, name } from '../../const';
import { styled } from '../../../../theme';

export const Puller = styled('div', { name, slot: 'Puller' })(({ theme }) => ({
  padding: `${MODAL_PULLER_VERTICAL_SPACING}px ${theme.spacing(1)}`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '&:before': {
    content: '""',
    width: PULLER_WIDTH,
    height: PULLER_HEIGHT,
    borderRadius: `${PULLER_HEIGHT / 2}px`,
    backgroundColor: Tokens.PullerColor(),
  },
}));
